
    var riot = require('riot')
    //src: starling/src/tags/sketchpad.html
riot.tag2('sketchpad',
  '<svg class="link-{defaults.color}" ref="drawing" onmousemove="{handleMouseMove}" onmouseup="{handleMouseUp}" onmousedown="{handleMouseDown}" riot-style="{getStyle()}"> <path riot-d="{getPath()}"></path> </svg>',
  '',
  'class="sketchpad"', function(opts) {
'use strict';

var _this = this;

var _drawingUi = require('lib/drawing-ui');

var _constants = require('lib/constants');

this.penDown = false;
this.canvas = this.opts.canvas;
this.canvas.sketchpadTag = this;

this.defaults = _drawingUi.drawingUI.getDefaults();

this.points = [];

this.getStyle = function () {
  var _defaults = _this.defaults,
      opacity = _defaults.opacity,
      strokeWidth = _defaults.strokeWidth;

  return '\n      --sketchpad-drawing-opacity: ' + opacity + ';\n      --sketchpad-drawing-stroke-width: ' + _constants.DRAWING_WIDTHS_MAPPING[strokeWidth] + 'px;\n      ';
};

this.handleMouseDown = function (e) {
  _this.penDown = true;
};

this.handleMouseUp = function (e) {
  var _refs$drawing$getBBox = _this.refs.drawing.getBBox(),
      x = _refs$drawing$getBBox.x,
      y = _refs$drawing$getBBox.y,
      width = _refs$drawing$getBBox.width,
      height = _refs$drawing$getBBox.height;

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var _defaults2 = _this.defaults,
      strokeWidth = _defaults2.strokeWidth,
      opacity = _defaults2.opacity,
      color = _defaults2.color;

  _drawingUi.drawingUI.createDrawing({
    path: _this.getPath(),
    top: (y - ty) / scale,
    left: (x - tx) / scale,
    bottom: (y + height - ty) / scale,
    right: (x + width - tx) / scale,
    y: y,
    x: x,
    height: height,
    width: width,
    color: color,
    strokeWidth: strokeWidth,
    opacity: opacity
  });

  _this.penDown = false;
  _this.points.length = 0;
  _this.update();
  _this.penX = null;
  _this.penY = null;
};

this.handleMouseMove = function (e) {
  if (_this.penDown) {
    _this.penX = e.clientX;
    _this.penY = e.clientY;
  }
};

this.getPath = function () {
  if (_this.points.length < 2) {
    return 'M 0 0';
  }
  var pt = _this.points[0];
  return 'M ' + pt[0] + ' ' + pt[1] + ' ' + _this.points.slice(1).map(function (p) {
    return 'L ' + p[0] + ' ' + p[1];
  }).join(' ');
};

this.show = function () {
  _this.isShowing = true;
  _this.root.style.display = 'block';
};

this.hide = function () {
  _this.isShowing = false;
  _this.root.style.display = 'none';
};

this.storePoints = function () {
  var penX = _this.penX,
      penY = _this.penY,
      points = _this.points,
      penDown = _this.penDown;

  if (penDown && penX && penY) {
    points.push([penX, penY]);
    _this.update();
  }

  window.requestAnimationFrame(_this.storePoints);
};

this.on('mount', function () {
  window.requestAnimationFrame(_this.storePoints);
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('sketchpad')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/sketchpad.html
// module id = 808
// module chunks = 0